import React, { useCallback } from "react";
import { RadioButton, RadioButtonGroup } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { LIBRARY_AGENDAS } from "../../types/agenda";
export var AgendaHandlerChoice = function (_a) {
    var name = _a.name, value = _a.value, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var handleChange = useCallback(function (agenda) { return function () { return onChange(agenda); }; }, [onChange]);
    return (React.createElement(RadioButtonGroup, { label: formatMessage({
            id: "ui-br-legaldeposits.agenda.issue.handler.label",
        }) }, LIBRARY_AGENDAS.map(function (agenda) { return (React.createElement(RadioButton, { key: agenda, name: name, label: formatMessage({
            id: "ui-br-legaldeposits.agenda.issue.handler.".concat(agenda),
        }), checked: value === agenda, onChange: handleChange(agenda) })); })));
};
